// If you are adding a term to the ActionSubjectId glossary,
// please add a member of the Data team to your PR

// For help naming UI components, see:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329336/UI+Events

// For help naming track event entities, see:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329319/Track+Events

// Screens that are e.g. closed or dismissed via sendClosedComponentEvent or sendDismissedComponentEvent
const inlineDialogs = {
  boardMenuDrawerEnterpriseUpsellInlineDialog:
    'boardMenuDrawerEnterpriseUpsellInlineDialog',
  boardsMenuInlineDialog: 'boardsMenuInlineDialog',
  createBoardBackgroundChooserInlineDialog:
    'createBoardBackgroundChooserInlineDialog',
  pupLimitBCUpsellInlineDialog: 'pupLimitBCUpsellInlineDialog',
  reactionSelectorInlineDialog: 'reactionSelectorInlineDialog',
  searchInlineDialog: 'searchInlineDialog',
  tacoTemplateTipsInlineDialog: 'tacoTemplateTipsInlineDialog',
  teamTemplatePickerInlineDialog: 'teamTemplatePickerInlineDialog',
} as const;

const modals = {
  freeTrialModal: 'freeTrialModal',
} as const;

// Sections on a page, e.g. in the home feed, card back, settings page
// web/guide/concepts/analytics.md for further guidance
const sections = {
  teamTemplatePickerSection: 'teamTemplatePickerSection',
  yourItemsSection: 'yourItemsSection',
} as const;

// Items within the sections
const sectionItems = {
  atlassianAccountSectionMessage: 'atlassianAccountSectionMessage',
  templateTileSectionItem: 'templateTileSectionItem',
} as const;

// Banners are commonly displayed between the app header and the board header
const banners = {
  atlassianAccessAdBanner: 'atlassianAccessAdBanner',
  atlassianAccountAutomaticOnboardingBanner:
    'atlassianAccountAutomaticOnboardingBanner',
  atlassianAccountMigrationBanner: 'atlassianAccountMigrationBanner',
  atlassianAccountOnboardingBanner: 'atlassianAccountOnboardingBanner',
  boardLimitsDowngradeBanner: 'boardLimitsDowngradeBanner',
  browserWillBeUnsupportedBanner: 'browserWillBeUnsupportedBanner',
  emailHygieneBanner: 'emailHygieneBanner',
  emailVerificationBanner: 'emailVerificationBanner',
  enterpriseDeprovisioningBanner: 'enterpriseDeprovisioningBanner',
  enterpriseLicenseBanner: 'enterpriseLicenseBanner',
  freeTeamLimitWarningBanner: 'freeTeamLimitWarningBanner',
  freeTeamLimitRestrictedBanner: 'freeTeamLimitRestrictedBanner',
  freeTrialBanner: 'freeTrialBanner',
  invitedBanner: 'invitedBanner',
  loggedInPublicBoardBanner: 'loggedInPublicBoardBanner',
  newLocaleBanner: 'newLocaleBanner',
  overdueBanner: 'overdueBanner',
  personalBoardsOwnershipBanner: 'personalBoardsOwnershipBanner',
  setPasswordBanner: 'setPasswordBanner',
  upgradePromptBanner: 'upgradePromptBanner',
} as const;

// UI elements
const buttons = {
  actionableTaskButton: 'actionableTaskButton',
  addAnotherCardButton: 'addAnotherCardButton',
  addAnotherListButton: 'addAnotherListButton',
  addMoreBoardsButton: 'addMoreBoardsButton',
  addPaymentButton: 'addPaymentButton',
  addTeamFromCollectionsButton: 'addTeamFromCollectionsButton',
  addToEnterpriseButton: 'addToEnterpriseButton',
  annualBillingButton: 'annualBillingButton',
  allBoardMembersButton: 'allBoardMembersButton',
  applyDiscountButton: 'applyDiscountButton',
  atlassianAccountCompleteOnboardingSuccessButton:
    'atlassianAccountCompleteOnboardingSuccessButton',
  atlassianAccountOnboardingBannerSnoozeButton:
    'atlassianAccountOnboardingBannerSnoozeButton',
  atlassianAccountOnboardingContinueButton:
    'atlassianAccountOnboardingContinueButton',
  atlassianAccountOnboardingForWorkButton:
    'atlassianAccountOnboardingForWorkButton',
  atlassianAccountOnboardingNotWorkButton:
    'atlassianAccountOnboardingNotWorkButton',
  atlassianAccountOnboardingOverlayCloseButton:
    'atlassianAccountOnboardingOverlayCloseButton',
  atlassianAccountOnboardingSuccessOverlay:
    'atlassianAccountOnboardingSuccessOverlay',
  atlassianAccountOnboardingUrgentContinueButton:
    'atlassianAccountOnboardingUrgentContinueButton',
  atlassianAccountOnboardingUrgentUpdate:
    'atlassianAccountOnboardingUrgentUpdate',
  atlassianAccountOnboardingWarningOverlay:
    'atlassianAccountOnboardingWarningOverlay',
  atlassianAutomaticOnboardingUpdateAccountButton:
    'atlassianAutomaticOnboardingUpdateAccountButton',
  atlassianAutomaticOnboardingCompleteButton:
    'atlassianAutomaticOnboardingCompleteButton',
  atlassianAutomaticAccountOnboardingOverlayCloseButton:
    'atlassianAutomaticAccountOnboardingOverlayCloseButton',
  atlassianAutomaticOnboardingContinueToAtlassianButton:
    'atlassianAutomaticOnboardingContinueToAtlassianButton',
  atlassianAutomaticOnboardingMismatchLoginButton:
    'atlassianAutomaticOnboardingMismatchLoginButton',
  atlassianAutomaticOnboardingConfirmationButton:
    'atlassianAutomaticOnboardingConfirmationButton',
  atlassianOnboardingGotItButton: 'atlassianOnboardingGotItButton',
  atlassianOnboardingGoToSettingsToRemoveEmailButton:
    'atlassianOnboardingGoToSettingsToRemoveEmailButton',
  atlassianOnboardingHelpDocButton: 'atlassianOnboardingHelpDocButton',
  atlassianOnboardingLoginWithAtlassianButton:
    'atlassianOnboardingLoginWithAtlassianButton',
  atlassianOnboardingMenuBackButton: 'atlassianOnboardingMenuBackButton',
  atlassianOnboardingMixedUseAccountButton:
    'atlassianOnboardingMixedUseAccountButton',
  atlassianOnboardingPersonalAccountButton:
    'atlassianOnboardingPersonalAccountButton',
  atlassianOnboardingRemoveEmailButton: 'atlassianOnboardingRemoveEmailButton',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  attachmentGetPowerEnableButton: 'attachmentGetPowerEnableButton',
  autoEnableCalendarDisableButton: 'autoEnableCalendarDisableButton',
  autoEnableCalendarOpenDirectoryButton:
    'autoEnableCalendarOpenDirectoryButton',
  autoEnableCalendarPrimaryButton: 'autoEnableCalendarPrimaryButton',
  avatarGravatarOptionButton: 'avatarGravatarOptionButton',
  avatarNoneOptionButton: 'avatarNoneOptionButton',
  avatarPreviouslyUploadedOptionButton: 'avatarPreviouslyUploadedOptionButton',
  backButton: 'backButton',
  bcUpgradeFromTemplatesPowerUpButton: 'bcUpgradeFromTemplatesPowerUpButton',
  boardButton: 'boardButton', // for power-up board buttons
  boardDirectoryCloseButton: 'boardDirectoryCloseButton',
  boardMenuDrawerCloseButton: 'boardMenuDrawerCloseButton',
  boardOrganizationButton: 'boardOrganizationButton',
  boardsMenuButton: 'boardsMenuButton',
  boardViewsButton: 'boardViewsButton',
  browseButton: 'browseButton',
  calendarPowerUpBoardButton: 'calendarPowerUpBoardButton',
  cancelBusinessClassButton: 'cancelBusinessClassButton',
  closeCancelBusinessClassModalButton: 'closeCancelBusinessClassModalButton',
  cancelButton: 'cancelButton',
  cancelEditDescriptionButton: 'cancelEditDescriptionButton',
  cancelTrelloGoldButton: 'cancelTrelloGoldButton',
  cardButton: 'cardButton',
  cardComposerMenuButton: 'cardComposerMenuButton',
  cardMapEditLocationButton: 'cardMapEditLocationButton',
  cardMapLocationButton: 'cardMapLocationButton',
  changeBoardOrganizationButton: 'changeBoardOrganizationButton',
  changeBoardVisibilityButton: 'changeBoardVisibilityButton',
  changeCreditCardButton: 'changeCreditCardButton',
  changeCreditCardForm: 'changeCreditCardForm',
  changeEmailButton: 'changeEmailButton',
  chargeMonthlyButon: 'chargeMonthlyButton',
  chargeYearlyButon: 'chargeYearlyButton',
  clearBoardFilterButton: 'clearBoardFilterButton',
  configureTwoFactorAuthButton: 'configureTwoFactorAuthButton',
  convertToTemplateButton: 'convertToTemplateButton',
  copyBoardButton: 'copyBoardButton',
  copyLinkButton: 'copyLinkButton',
  createBoardButton: 'createBoardButton',
  createBoardFromTemplateButton: 'createBoardFromTemplateButton',
  createCardButton: 'createCardButton',
  createCardFromTemplateButton: 'createCardFromTemplateButton',
  createNewAccountButton: 'createNewAccountButton',
  dismissButton: 'dismissButton',
  downgradeToFreeButton: 'downgradeToFreeButton',
  editDescriptionButton: 'editDescriptionButton',
  emailButton: 'emailButton', // social share button
  emptyPowerUpSlotButton: 'emptyPowerUpSlotButton',
  enterpriseButton: 'enterpriseButton',
  exportButton: 'exportButton',
  boardFilterButton: 'boardFilterButton',
  facebookButton: 'facebookButton',
  formattingHelpDescriptionButton: 'formattingHelpDescriptionButton',
  getStartedButton: 'getStartedButton',
  getStartedTypeformButton: 'getStartedTypeformButton',
  inviteTeamMembersButton: 'inviteTeamMembersButton',
  inviteToBoardButton: 'inviteToBoardButton',
  inviteToBoardLinkCopyButton: 'inviteToBoardLinkCopyButton',
  joinBoardButton: 'joinBoardButton',
  keepPhotoButton: 'keepPhotoButton',
  keepBusinessClassButton: 'keepBusinessClassButton',
  learnMoreButton: 'learnMoreButton',
  linkCopyButton: 'linkCopyButton',
  linkedinButton: 'linkedinButton',
  listMenuButton: 'listMenuButton',
  marketingOptInButton: 'marketingOptInButton',
  marketingOptOutButton: 'marketingOptOutButton',
  monthlyBillingButton: 'monthlyBillingButton',
  powerUpAddButton: 'powerUpAddButton',
  powerUpBoardButton: 'powerUpBoardButton',
  powerUpCardButton: 'powerUpCardButton',
  powerUpEditButton: 'powerUpEditButton',
  powerUpSlotButton: 'powerUpSlotButton',
  purchaseBusinessClassButton: 'purchaseBusinessClassButton',
  purchaseGoldButton: 'purchaseGoldButton',
  removeEmailButton: 'removeEmailButton',
  renewBusinessClassButton: 'renewBusinessClassButton',
  renewTrelloGoldButton: 'renewTrelloGoldButton',
  restoreBCButton: 'restoreBCButton',
  setAsPrimaryEmailButton: 'setAsPrimaryEmailButton',
  setUpAtlassianAccountAndRemoveEmailsButton:
    'setUpAtlassianAccountAndRemoveEmailsButton',
  shareButton: 'shareButton',
  showAllActivityButton: 'showAllActivityButton',
  showAllPowerUpsButton: 'showAllPowerUpsButton',
  showCommentsOnlyButton: 'showCommentsOnlyButton',
  showFewerPowerUpsButton: 'showFewerPowerUpsButton',
  showFullDescriptionButton: 'showFullDescriptionButton',
  showMoreYourItemsButton: 'showMoreYourItemsButton',
  signUpButton: 'signUpButton',
  startFreeTrialButton: 'startFreeTrialButton',
  tacoTemplateTipsButton: 'tacoTemplateTipsButton',
  tryBackgroundButton: 'tryBackgroundButton',
  twitterButton: 'twitterButton',
  upgradeButton: 'upgradeButton',
  upgradeToBCButton: 'upgradeToBCButton',
  useTemplateButton: 'useTemplateButton',
  viewTemplateButton: 'viewTemplateButton',
  copyTemplateButton: 'copyTemplateButton',
  dismissTemplateButton: 'dismissTemplateButton',
  changeOrgProfileButton: 'changeOrgProfileButton',
  unfurlActionButton: 'unfurlActionButton',
  saveAttachmentButton: 'saveAttachmentButton',
  workspacesPreambleBoardInviteButton: 'workspacesPreambleBoardInviteButton',
  workspacesPreambleAddToTeamButton: 'workspacesPreambleAddToTeamButton',
} as const;

const links = {
  aboutThisTemplateLink: 'aboutThisTemplateLink',
  alwaysKeepMenuOpenLink: 'alwaysKeepMenuOpenLink',
  atlassian2FALearnMoreLink: 'atlassian2FALearnMoreLink',
  atlassianAccessSeeDetailsLink: 'atlassianAccessSeeDetailsLink',
  attachmentGetPowerLearnMoreLink: 'attachmentGetPowerLearnMoreLink',
  backgroundOptionsLink: 'backgroundOptionsLink',
  bcUpgradeFromTemplatesPowerUpDescriptionLink:
    'bcUpgradeFromTemplatesPowerUpDescriptionLink',
  bcUpgradeFromTemplatesStoryHeaderLink:
    'bcUpgradeFromTemplatesStoryHeaderLink',
  boardMenuPowerUpLink: 'boardMenuPowerUpLink',
  boardMenuDrawerToggleLink: 'boardMenuDrawerToggleLink', // 'Show Menu' link in board header
  boardNameLink: 'boardNameLink',
  boardSearchResultLink: 'boardSearchResultLink',
  businessClassLink: 'businessClassLink',
  cardNameLink: 'cardNameLink',
  cardMapExternalLink: 'cardMapExternalLink',
  cardSearchResultLink: 'cardSearchResultLink',
  categoryNavLink: 'categoryNavLink',
  changeBoardOrganizationLink: 'changeBoardOrganizationLink',
  changePasswordLink: 'changePasswordLink',
  checkInboxLink: 'checkInboxLink',
  checkItemNameLink: 'checkItemNameLink',
  convertToTemplateLink: 'convertToTemplateLink',
  createBoardLink: 'createBoardLink',
  createCollectionLink: 'createCollectionLink',
  createNewOrgLink: 'createNewOrgLink',
  customBoardBackgroundLink: 'customBoardBackgroundLink',
  customPowerUpLearnMoreHeaderLink: 'customPowerUpLearnMoreHeaderLink',
  downloadLink: 'downloadLink',
  enterpriseLink: 'enterpriseLink',
  fullNameProfileLink: 'fullNameProfileLink',
  giveFeedbackLink: 'giveFeedbackLink',
  goldLink: 'goldLink',
  integrationsNavigationMenuLink: 'integrationsNavigationMenuLink',
  inviteTeamMemberLink: 'inviteTeamMemberLink',
  inviteToBoardDisableLink: 'inviteToBoardDisableLink',
  inviteToBoardLink: 'inviteToBoardLink',
  learnMoreLink: 'learnMoreLink',
  mapLocationPowerUpLink: 'mapLocationPowerUpLink',
  memberSearchResultLink: 'memberSearchResultLink',
  moonshotExploreLink: 'moonshotExploreLink',
  resendEmailLink: 'resendEmailLink',
  seeClosedBoardsLink: 'seeClosedBoardsLink',
  shareTemplateLink: 'shareTemplateLink',
  showLessActiveBoardsLink: 'showLessActiveBoardsLink',
  showMoreCardsLink: 'showMoreCardsLink',
  showSearchTipsLink: 'showSearchTipsLink',
  startWithTemplateLink: 'startWithTemplateLink',
  submitTemplateLink: 'submitTemplateLink',
  teamBillingPageLink: 'teamBillingPageLink',
  teamInvitation: 'teamInvitation',
  teamPageLink: 'teamPageLink',
  teamSearchResultLink: 'teamSearchResultLink',
  templatesHelpLink: 'templatesHelpLink',
  templateLink: 'templateLink',
  twoFactorAuthBackupCodesLink: 'twoFactorAuthBackupCodesLink',
  updateAccountLink: 'updateAccountLink',
  updateBillingInfoLink: 'updateBillingInfoLink',
  updateProfileLink: 'updateProfileLink',
  upgradeBrowserLink: 'upgradeBrowserLink',
  upgradeToBCLink: 'upgradeToBCLink',
  viewOrganizationLink: 'viewOrganizationLink',
} as const;

const inputFields = {
  boardNameInput: 'boardNameInput',
  linkCopyInput: 'linkCopyInput',
  searchInput: 'searchInput',
  fileInputUpload: 'fileInputUpload',
} as const;

const pills = {
  bcUpgradePill: 'bcUpgradePill',
} as const;

// For links in the board menu drawer
const drawerNavigationItems = {
  cardCoversDrawerNavigationItem: 'cardCoversDrawerNavigationItem',
  changeOrgDrawerNavigationItem: 'changeOrgDrawerNavigationItem',
  closeBoardDrawerNavigationItem: 'closeBoardDrawerNavigationItem',
  convertToBoardDrawerNavigationItem: 'convertToBoardDrawerNavigationItem',
  commentPermsDrawerNavigationItem: 'commentPermsDrawerNavigationItem',
  cookieConsentDrawerNavigationItem: 'cookieConsentDrawerNavigationItem',
  copyBoardDrawerNavigationItem: 'copyBoardDrawerNavigationItem',
  invitationsPermsDrawerNavigationItem: 'invitationsPermsDrawerNavigationItem',
  leaveDrawerNavigationItem: 'leaveDrawerNavigationItem',
  makeTemplateFromBoardDrawerNavigationItem:
    'makeTemplateFromBoardDrawerNavigationItem',
  powerUpDirectoryDrawerNavigationItem: 'powerUpDirectoryDrawerNavigationItem',
  removeOrgDrawerNavigationItem: 'removeOrgDrawerNavigationItem',
  selfJoinDrawerNavigationItem: 'selfJoinDrawerNavigationItem',
  votingPermsDrawerNavigationItem: 'votingPermsDrawerNavigationItem',
  watchDrawerNavigationItem: 'watchDrawerNavigationItem',
} as const;

// For info boxes, callouts within a component
const overlays = {
  atlassianAccountOnboardingAccountUpdateOverlay:
    'atlassianAccountOnboardingAccountUpdateOverlay',
  atlassianAccountOnboardingAutomaticMigrationOverlay:
    'atlassianAccountOnboardingAutomaticMigrationOverlay',
  atlassianAccountOnboardingAtlassianMigrationConfirmationOverlay:
    'atlassianAccountOnboardingAtlassianMigrationConfirmationOverlay',
  atlassianAccountOnboardingAtlassianProfileOverlay:
    'atlassianAccountOnboardingAtlassianProfileOverlay',
  collectionsExplainerOverlay: 'collectionsExplainerOverlay',
} as const;

// For options within a dropdown component
const dropdownItems = {
  inviteTeamToBoardDropdownItem: 'inviteTeamToBoardDropdownItem',
  listViewDropdownItem: 'listViewDropdownItem',
  calendarViewDropdownItem: 'calendarViewDropdownItem',
  mapViewDropdownItem: 'mapViewDropdownItem',
} as const;

// For tracking set, change, etc of board preferences
const boardPrefs = {
  hideVotesBoardPref: 'hideVotesBoardPref',
  votingBoardPref: 'votingBoardPref',
} as const;

const shortcuts = {
  boardsMenuShortcut: 'boardsMenuShortcut',
  clearAllFiltersShortcut: 'clearAllFiltersShortcut',
  escapeShortcut: 'escapeShortcut',
  insertCardShortcut: 'insertCardShortcut',
  moveDownShortcut: 'moveDownShortcut',
  moveLeftShortcut: 'moveLeftShortcut',
  moveRightShortcut: 'moveRightShortcut',
  moveUpShortcut: 'moveUpShortcut',
  myCardsShortcut: 'myCardsShortcut',
  searchAndFilterCardsShortcut: 'searchAndFilterCardsShortcut',
  searchShortcut: 'searchShortcut',
  toggleBoardMenuDrawerShortcut: 'toggleBoardMenuDrawerShortcut',
  toggleLabelTextShortcut: 'toggleLabelTextShortcut',
} as const;

const menuItems = {
  addCardMenuItem: 'addCardMenuItem',
  archiveAllCardsMenuItem: 'archiveAllCardsMenuItem',
  copyListMenuItem: 'copyListMenuItem',
  moveAllCardsMenuItem: 'moveAllCardsMenuItem',
  moveListMenuItem: 'moveListMenuItem',
  sortListMenuItem: 'sortListMenuItem',
} as const;

const icons = {
  infoIcon: 'infoIcon',
  reactionMenuIcon: 'reactionMenuIcon',
} as const;

const tabs = {
  boardsTab: 'boardsTab', // To track tab click that loads the boardsHomeScreen
  homeTab: 'homeTab', // To track tab click that loads the memberHomeScreen
  templateGalleryTab: 'templateGalleryTab',
} as const;

// Team-specific terms
const atlassianAccountMigrationTerms = {
  atlassianAccountMigrationBannerLink: 'atlassianAccountMigrationBannerLink',
  atlassianAccountMigrationBannerDismissLink:
    'atlassianAccountMigrationBannerDismissLink',
  atlassianAccountMigrationRetryButton: 'atlassianAccountMigrationRetryButton',
  atlassianAccountMigrationChangeEmailButton:
    'atlassianAccountMigrationChangeEmailButton',
  atlassianAccountMigrationOverlay: 'atlassianAccountMigrationOverlay',
} as const;

const emailHygieneTerms = {
  emailHygieneBannerLink: 'emailHygieneBannerLink',
  emailHygieneBannerDismissLink: 'emailHygieneBannerDismissLink',
  emailHygieneWizard: 'emailHygieneWizard',
  emailHygieneWizardChangeEmailButton: 'emailHygieneWizardChangeEmailButton',
  emailHygieneWizardConfirmEmailButton: 'emailHygieneWizardConfirmEmailButton',
  emailHygieneWizardDismissLink: 'emailHygieneWizardDismissLink',
  emailHygieneWizardEmailItem: 'emailHygieneWizardEmailItem',
  emailHygieneWizardRemoveSecondaryEmailsButton:
    'emailHygieneWizardRemoveSecondaryEmailsButton',
  emailHygieneWizardScreenChooseEmail: 'emailHygieneWizardScreenChooseEmail',
  emailHygieneWizardScreenClaimableInfo:
    'emailHygieneWizardScreenClaimableInfo',
  emailHygieneWizardScreenConfirmationEmailSent:
    'emailHygieneWizardScreenConfirmationEmailSent',
  emailHygieneWizardScreenConfirmSingleEmail:
    'emailHygieneWizardScreenConfirmSingleEmail',
  emailHygieneWizardScreenError: 'emailHygieneWizardScreenError',
  emailHygieneWizardScreenSuccess: 'emailHygieneWizardScreenSuccess',
  emailHygieneTransferBoardsFooterLink: 'emailHygieneTransferBoardsFooterLink',
} as const;

export const jswCrossflowItems = {
  jswLearnMoreInlineDialog: 'jswLearnMoreInlineDialog',
  jswLearnMoreButton: 'jswLearnMoreButton',
  jswLearnMoreBanner: 'jswLearnMoreBanner',
  confluenceLearnMoreBanner: 'confluenceLearnMoreBanner',
  confluenceLearnMoreButton: 'confluenceLearnMoreButton',
} as const;

const otherActionSubjectIds = {
  atlassianAccountOnboardingOverlay: 'atlassianAccountOnboardingOverlay',
  assignedCheckItem: 'assignedCheckItem',
  bcFreeTrial: 'bcFreeTrial',
  bcFreeTrialUpsell: 'bcFreeTrialUpsell',
  bcPayment: 'bcPayment',
  bcTeam: 'bcTeam',
  bcUpgradePrompt: 'bcUpgradePrompt',
  bcUpgradeSurvey: 'bcUpgradeSurvey',
  boardDescription: 'boardDescription',
  boardInvitation: 'boardInvitation', // Adding members to board
  boardSelectorTile: 'boardSelectorTile',
  businessClassUpgrade: 'businessClassUpgrade',
  cardComposerList: 'cardComposerList',
  cardComposerPosition: 'cardComposerPosition',
  cardDescription: 'cardDescription',
  cardDetailBadge: 'cardDetailBadge',
  cardMapLocation: 'cardMapLocation',
  cardMember: 'cardMember',
  cardTitleSeparator: 'cardTitleSeparator',
  closedBoardsModal: 'closedBoardsModal',
  colorBlindFriendlyMode: 'colorBlindFriendlyMode',
  colorBoardBackground: 'colorBoardBackground',
  commentReaction: 'commentReaction',
  customBoardBackground: 'customBoardBackground',
  descriptionEdit: 'descriptionEdit',
  dismissPluginSuggestionButton: 'dismissPluginSuggestionButton',
  dueDateBadge: 'dueDateBadge',
  editSettingsOption: 'editSettingsOption',
  emailBoardInvitation: 'emailBoardInvitation', // For new members invited to board
  freeTeam: 'freeTeam',
  fullUpgradePrompt: 'fullUpgradePrompt',
  learnMoreAboutBCButton: 'learnMoreAboutBCButton',
  leaveBoardMenu: 'leaveBoardMenu',
  listLimit: 'listLimit',
  marketingEmail: 'marketingEmail',
  moonshotStep: 'moonshotStep',
  miniProfileAvatar: 'miniProfileAvatar',
  objectResolverClient: 'objectResolverClient',
  photoBoardBackground: 'photoBoardBackground',
  pupCardBadge: 'pupCardBadge',
  pupCardDetailBadge: 'pupCardDetailBadge',
  powerUpCard: 'powerUpCard',
  savingSearchQuery: 'savingSearchQuery',
  searchMember: 'searchMember',
  searchResultCard: 'searchResultCard',
  searchSuggestion: 'searchSuggestion',
  searchTeam: 'searchTeam',
  templatePreview: 'templatePreview',
  templateTile: 'templateTile',
  unknown: 'unknown', // This represents a generic error case and should be used sparingly!
} as const;

export const ActionSubjectId = {
  ...inlineDialogs,
  ...modals,
  ...buttons,
  ...links,
  ...inputFields,
  ...pills,
  ...drawerNavigationItems,
  ...overlays,
  ...dropdownItems,
  ...boardPrefs,
  ...tabs,
  ...shortcuts,
  ...menuItems,
  ...sections,
  ...sectionItems,
  ...icons,
  ...banners,
  ...atlassianAccountMigrationTerms,
  ...emailHygieneTerms,
  ...jswCrossflowItems,
  ...otherActionSubjectIds,
} as const;

export type ActionSubjectIdType = typeof ActionSubjectId[keyof typeof ActionSubjectId];
